import React, { useState } from 'react';
import {
  Table, Card, Button, Space, Typography, Form, Input, Select, DatePicker,
  Tag, Drawer, Descriptions, Alert, message, Modal
} from 'antd';
import { SearchOutlined, ReloadOutlined, DownloadOutlined, FileTextOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;
const { Option } = Select;
const { RangePicker } = DatePicker;
const MonthPicker = DatePicker;

const ShareIncome = () => {
  const [form] = Form.useForm();
  const [orderForm] = Form.useForm();
  const [detailVisible, setDetailVisible] = useState(false);
  const [detailRecord, setDetailRecord] = useState(null);

  // ─── 导出月账单 Modal 状态 ───
  const [exportVisible, setExportVisible] = useState(false);
  const [exportEnt, setExportEnt] = useState(null);       // { entId, entName }
  const [exportMonth, setExportMonth] = useState(null);    // dayjs
  const [exportPreview, setExportPreview] = useState(null); // { totalCNY, totalUSD, orderCount, billCount, bills }
  const [exportLoading, setExportLoading] = useState(false);

  const dataSource = [
    { key: '1', billNo: 'SI202604-001', entName: '深圳星辰物联科技有限公司', entId: 'SZ-XC-001', rate: 5.00, billDate: '2026-04-26', orderCount: 112, totalCNY: 6800.00, totalUSD: 950.00, billType: 'system', remark: '',
      orders: [
        { key: 'o1', orderNo: 'ORD202604-101', license: 'LI06219437', packageName: '云存储月卡', packageId: 'PKG001', serviceCategory: '云端存储', basePrice: 10.00, discount: 0.9, payChannel: '微信支付', currency: 'CNY', amount: 29.90, feeRate: '0.38%', feeAmount: 0.11, fixedFee: 0.06, payTime: '2026-04-25 10:00:00' },
        { key: 'o2', orderNo: 'ORD202604-102', license: 'LI08753162', packageName: '云存储年卡', packageId: 'PKG002', serviceCategory: '云端存储', basePrice: 10.00, discount: 0.9, payChannel: '支付宝', currency: 'CNY', amount: 199.00, feeRate: '0.38%', feeAmount: 0.76, fixedFee: 0.06, payTime: '2026-04-25 14:30:00' },
        { key: 'o3', orderNo: 'ORD202604-103', license: 'LI04518290', packageName: 'Cloud Storage Monthly', packageId: 'PKG101', serviceCategory: '云端存储', basePrice: 10.00, payChannel: 'Stripe', currency: 'USD', amount: 4.99, feeRate: '2.9%', feeAmount: 0.14, fixedFee: 0.50, payTime: '2026-04-25 09:00:00' },
      ]
    },
    { key: '2', billNo: 'SI202604-002', entName: '捷顺科技股份有限公司', entId: 'A619355x', rate: 3.00, billDate: '2026-04-26', orderCount: 67, totalCNY: 3200.00, totalUSD: 480.00, billType: 'system', remark: '',
      orders: [
        { key: 'o4', orderNo: 'ORD202604-201', license: 'LI02637845', packageName: '4G流量包', packageId: 'PKG003', payChannel: '微信支付', currency: 'CNY', amount: 15.00, feeRate: '0.38%', feeAmount: 0.06, fixedFee: 0.06, payTime: '2026-04-25 16:00:00' },
        { key: 'o5', orderNo: 'ORD202604-202', license: 'LI07194503', packageName: 'Cloud Storage Annual', packageId: 'PKG102', payChannel: 'PayPal', currency: 'USD', amount: 49.99, feeRate: '3.5%', feeAmount: 1.75, payTime: '2026-04-25 11:00:00' },
      ]
    },
    { key: '3', billNo: 'SI202603-001', entName: '深圳星辰物联科技有限公司', entId: 'SZ-XC-001', rate: 5.00, billDate: '2026-03-11', orderCount: 85, totalCNY: 5100.00, totalUSD: 720.00, billType: 'system', remark: '', orders: [] },
    { key: '4', billNo: 'ADJ202604-001', entName: '深圳星辰物联科技有限公司', entId: 'SZ-XC-001', rate: null, billDate: '2026-04-27', orderCount: 0, totalCNY: -500.00, totalUSD: 0, billType: 'adjust', remark: '3月账单多计云存储订单，冲回差额', orders: [] },
  ];

  // ─── 当选择了企业和月份后，自动计算预览 ───
  const loadPreview = (entId, month) => {
    if (!entId || !month) { setExportPreview(null); return; }
    // Mock：任意月份均有数据
    setExportPreview({
      totalCNY: 12580.50, totalUSD: 1840.00, orderCount: 47, bills: [], empty: false,
    });
  };

  const columns = [
    { title: '账单编号', dataIndex: 'billNo', width: 150, render: (t) => <Text copyable style={{ fontFamily: 'monospace', fontSize: 13 }}>{t}</Text> },
    { title: '分润上级', key: 'ent', width: 200, render: (_, r) => (<div><div style={{ fontWeight: 500 }}>{r.entName}</div><Text type="secondary" style={{ fontSize: 12 }}>{r.entId}</Text></div>) },
    { title: '分润比例', dataIndex: 'rate', width: 90, render: (v) => v != null ? <Tag color="orange">{v.toFixed(2)}%</Tag> : <span style={{ color: '#ccc' }}>-</span> },
    { title: '账单日期', dataIndex: 'billDate', width: 120 },
    { title: '出账方式', dataIndex: 'billType', width: 100, render: (v) => <Tag color={v === 'system' ? 'blue' : 'warning'}>{v === 'system' ? '系统出账' : '人工冲账'}</Tag> },
    { title: '分润订单数', dataIndex: 'orderCount', width: 100, align: 'right', render: (v, r) => r.billType === 'adjust' ? <span style={{ color: '#ccc' }}>-</span> : <Button type="link" style={{ padding: 0, fontWeight: 600 }} onClick={() => { setDetailRecord(r); setDetailVisible(true); orderForm.resetFields(); }}>{v} 笔</Button> },
    { title: '分润总额', key: 'total', width: 150, align: 'right', render: (_, r) => (<div><div><Text strong style={{ color: (r.totalCNY || 0) < 0 ? '#ff4d4f' : '#52c41a' }}>{(r.totalCNY || 0) < 0 ? '-' : ''}¥ {Math.abs(r.totalCNY || 0).toFixed(2)}</Text></div>{r.totalUSD > 0 && <div><Text strong style={{ color: '#52c41a' }}>$ {(r.totalUSD || 0).toFixed(2)}</Text></div>}</div>) },
    { title: '冲账原因', dataIndex: 'remark', width: 180, ellipsis: true, render: (v) => v || <span style={{ color: '#ccc' }}>-</span> },
  ];

  return (
    <div style={{ padding: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <Title level={4} style={{ margin: 0 }}>分润收益</Title>
        <Button icon={<FileTextOutlined />} onClick={() => { setExportVisible(true); setExportEnt(null); setExportMonth(null); setExportPreview(null); }}>
          导出月账单
        </Button>
      </div>

      <Alert type="info" showIcon style={{ marginBottom: 8, borderRadius: 8 }} message="分成收益账单按 T+1 入账，即分润上级订单产生后次日自动计入您的收益账单。" />

      <Card bordered={false} style={{ marginBottom: 8, borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }} bodyStyle={{ padding: '12px 0' }}>
        <Form form={form} layout="inline" style={{ gap: 0 }}>
          <Form.Item name="billNo" style={{ marginRight: 8 }}><Input placeholder="账单编号" allowClear style={{ width: 160 }} /></Form.Item>
          <Form.Item style={{ marginRight: 8 }}>
            <Space.Compact>
              <Form.Item name="entType" initialValue="name" noStyle><Select style={{ width: 100 }}><Option value="name">分润上级</Option><Option value="id">企业ID</Option></Select></Form.Item>
              <Form.Item shouldUpdate={(p, c) => p.entType !== c.entType} noStyle>
                {({ getFieldValue }) => getFieldValue('entType') === 'id' ? (<Form.Item name="ent" noStyle><Input placeholder="企业ID" allowClear style={{ width: 200 }} /></Form.Item>) : (<Form.Item name="ent" noStyle><Select placeholder="请选择分润上级" allowClear showSearch optionFilterProp="label" style={{ width: 200 }} options={dataSource.map(d => ({ value: d.entId, label: d.entName })).filter((v, i, a) => a.findIndex(t => t.value === v.value) === i)} /></Form.Item>)}
              </Form.Item>
            </Space.Compact>
          </Form.Item>
          <Form.Item name="billDate" style={{ marginRight: 8 }}><RangePicker placeholder={['账单开始日期', '账单结束日期']} /></Form.Item>
          <Form.Item style={{ marginRight: 0 }}><Space><Button type="primary" icon={<SearchOutlined />}>查询</Button><Button icon={<ReloadOutlined />} onClick={() => form.resetFields()}>重置</Button></Space></Form.Item>
        </Form>
      </Card>

      <Card bordered={false}>
        <div style={{ display: 'flex', gap: 24, marginBottom: 12, padding: '8px 16px', background: '#fafafa', borderRadius: 6 }}>
          <span><Text type="secondary">人民币小计：</Text><Text strong style={{ color: '#52c41a' }}>¥ {dataSource.reduce((s, r) => s + (r.totalCNY || 0), 0).toFixed(2)}</Text></span>
          <span><Text type="secondary">美元小计：</Text><Text strong style={{ color: '#52c41a' }}>$ {dataSource.reduce((s, r) => s + (r.totalUSD || 0), 0).toFixed(2)}</Text></span>
          <span><Text type="secondary">人民币总计：</Text><Text strong style={{ color: '#1890ff' }}>¥ {dataSource.reduce((s, r) => s + (r.totalCNY || 0), 0).toFixed(2)}</Text></span>
          <span><Text type="secondary">美元总计：</Text><Text strong style={{ color: '#1890ff' }}>$ {dataSource.reduce((s, r) => s + (r.totalUSD || 0), 0).toFixed(2)}</Text></span>
        </div>
        <Table columns={columns} dataSource={dataSource} rowKey="key" pagination={{ showSizeChanger: true, showTotal: (t) => `共 ${t} 条记录` }} />
      </Card>

      <Drawer title={`分润收益详情 - ${detailRecord?.billNo || ''}`} width="70%" onClose={() => setDetailVisible(false)} open={detailVisible} destroyOnClose>
        {detailRecord && (<>
          <Descriptions bordered column={2} size="small" style={{ marginBottom: 16 }}>
            <Descriptions.Item label="账单编号">{detailRecord.billNo}</Descriptions.Item>
            <Descriptions.Item label="账单日期">{detailRecord.billDate}</Descriptions.Item>
            <Descriptions.Item label="分润上级">{detailRecord.entName}（{detailRecord.entId}）</Descriptions.Item>
            <Descriptions.Item label="分润比例">{detailRecord.rate != null ? <Tag color="orange">{detailRecord.rate.toFixed(2)}%</Tag> : '-'}</Descriptions.Item>
            <Descriptions.Item label="出账方式"><Tag color={detailRecord.billType === 'system' ? 'blue' : 'warning'}>{detailRecord.billType === 'system' ? '系统出账' : '人工冲账'}</Tag></Descriptions.Item>
            <Descriptions.Item label="分润总额"><Text strong style={{ color: (detailRecord.totalCNY || 0) < 0 ? '#ff4d4f' : '#52c41a' }}>{(detailRecord.totalCNY || 0) < 0 ? '-' : ''}¥ {Math.abs(detailRecord.totalCNY || 0).toFixed(2)}</Text>{detailRecord.totalUSD > 0 && <Text strong style={{ color: '#52c41a', marginLeft: 12 }}>$ {(detailRecord.totalUSD || 0).toFixed(2)}</Text>}</Descriptions.Item>
            {detailRecord.remark && <Descriptions.Item label="冲账原因" span={2}>{detailRecord.remark}</Descriptions.Item>}
          </Descriptions>

          <div style={{ marginBottom: 8 }}><Text strong>订单列表（{detailRecord.orderCount} 笔）</Text></div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
            <Form form={orderForm} layout="inline">
              <Form.Item name="orderNo" style={{ marginRight: 8 }}><Input placeholder="订单编号" allowClear style={{ width: 160 }} /></Form.Item>
              <Form.Item name="payTime" style={{ marginRight: 8 }}><RangePicker placeholder={['支付开始', '支付结束']} /></Form.Item>
              <Form.Item><Space><Button type="primary" size="small" icon={<SearchOutlined />}>查询</Button><Button size="small" onClick={() => orderForm.resetFields()}>重置</Button></Space></Form.Item>
            </Form>
            <Button size="small" icon={<DownloadOutlined />} onClick={() => message.success('导出成功')}>导出</Button>
          </div>
          <Table size="small" dataSource={detailRecord.orders || []} rowKey="key"
            pagination={{ showSizeChanger: true, showTotal: (t) => `共 ${t} 笔` }}
            columns={[
              { title: '订单编号', dataIndex: 'orderNo', width: 160, render: (t) => <Text copyable style={{ fontFamily: 'monospace', fontSize: 12 }}>{t}</Text> },
              { title: 'License', dataIndex: 'license', width: 140, render: (t) => t ? <Text copyable style={{ fontFamily: 'monospace', fontSize: 12 }}>{t}</Text> : '-' },
              { title: '套餐信息', dataIndex: 'packageName', width: 140, render: (v, r) => <div><div>{v}</div><Text type="secondary" style={{ fontSize: 11 }}>{r.packageId}</Text></div> },
              { title: '服务分类', dataIndex: 'serviceCategory', width: 90, render: (v) => v ? <Tag>{v}</Tag> : <span style={{ color: '#ccc' }}>-</span> },
              { title: '套餐底价', dataIndex: 'basePrice', width: 110, render: (v, r) => {
                if (!v && !r.basePrice) return <span style={{ color: '#ccc' }}>-</span>;
                const bp = r.basePrice || v;
                if (r.discount != null && r.discount !== 1) return <Text style={{ fontSize: 12 }}>{r.currency === 'CNY' ? '¥' : '$'}{bp?.toFixed(2)} × {r.discount}</Text>;
                return <Text style={{ fontSize: 12 }}>{r.currency === 'CNY' ? '¥' : '$'}{bp?.toFixed(2)}</Text>;
              }},
              { title: '支付通道', dataIndex: 'payChannel', width: 90, render: (v) => <Tag>{v}</Tag> },
              { title: '币种', dataIndex: 'currency', width: 60, render: (v) => <Tag color={v === 'CNY' ? 'green' : 'blue'}>{v}</Tag> },
              { title: '订单金额', dataIndex: 'amount', width: 100, align: 'right', render: (v, r) => <Text strong>{r.currency === 'CNY' ? '¥' : '$'} {v.toFixed(2)}</Text> },
              { title: '支付费率', dataIndex: 'feeRate', width: 140, align: 'right', render: (v, r) => {
                if (!v) return '-';
                return r.fixedFee != null ? `${v}+${r.fixedFee}${r.currency}` : v;
              } },
              { title: '支付手续费', dataIndex: 'feeAmount', width: 90, align: 'right', render: (v, r) => v != null ? <Text>{r.currency === 'CNY' ? '¥' : '$'} {v.toFixed(2)}</Text> : '-' },
              { title: '支付时间', dataIndex: 'payTime', width: 170, render: (t) => <Text type="secondary">{t}</Text> },
            ]}
          />
        </>)}
      </Drawer>

      {/* ══════════════════════════════════════════════
           导出月账单 Modal
           ══════════════════════════════════════════════ */}
      <Modal
        title="导出月账单"
        open={exportVisible}
        onCancel={() => setExportVisible(false)}
        width={560}
        footer={
          exportPreview && !exportPreview.empty
            ? [
                <Button key="cancel" onClick={() => setExportVisible(false)}>取消</Button>,
                <Button key="export" type="primary" icon={<DownloadOutlined />}
                  loading={exportLoading}
                  onClick={() => {
                    setExportLoading(true);
                    setTimeout(() => { setExportLoading(false); message.success('导出成功（汇总 + 明细已下载）'); setExportVisible(false); }, 1200);
                  }}>
                  导出 Excel
                </Button>,
              ]
            : [
                <Button key="close" onClick={() => setExportVisible(false)}>关闭</Button>,
              ]
        }
      >
        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
          {/* ① 分润上级 */}
          <div>
            <Text strong>① 分润上级</Text>
            <Select
              style={{ width: '100%', marginTop: 8 }}
              placeholder="请搜索并选择分润上级企业"
              showSearch
              allowClear
              optionFilterProp="label"
              value={exportEnt?.entId}
              onChange={(val) => {
                const ent = val ? dataSource.find(r => r.entId === val) : null;
                setExportEnt(ent ? { entId: ent.entId, entName: ent.entName } : null);
                setExportPreview(null);
              }}
              options={dataSource.map(r => ({ value: r.entId, label: `${r.entName} (${r.entId})` })).filter((v, i, a) => a.findIndex(t => t.value === v.value) === i)}
            />
          </div>

          {/* ② 账单月份 */}
          <div>
            <Text strong>② 账单月份</Text>
            <br />
            <MonthPicker
              style={{ width: '100%', marginTop: 8 }}
              picker="month"
              placeholder="选择月份"
              value={exportMonth}
              onChange={(val) => { setExportMonth(val); setExportPreview(null); }}
            />
          </div>

          {/* ③ 预览 */}
          {exportEnt && exportMonth && (
            <Button
              type="default"
              block
              onClick={() => loadPreview(exportEnt.entId, exportMonth)}
              icon={<SearchOutlined />}
            >
              查询预览
            </Button>
          )}
          {exportEnt && exportMonth && (
            <Button type="link" block size="small" style={{ color: '#999' }}
              onClick={() => setExportPreview({ empty: true })}>
              mock 无数据 demo
            </Button>
          )}

          {exportPreview && (
            exportPreview.empty ? (
              <Alert type="warning" showIcon message={`${exportEnt.entName} 在 ${exportMonth?.format('YYYY年M月')} 无账单记录`} />
            ) : (
              <Card size="small" style={{ background: '#fafafa', borderRadius: 8 }}>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 24 }}>
                  <div><Text type="secondary">企业：</Text><Text strong>{exportEnt.entName}</Text></div>
                  <div><Text type="secondary">月份：</Text><Text strong>{exportMonth?.format('YYYY年M月')}</Text></div>
                  <div><Text type="secondary">分润总额：</Text>
                    <Text strong style={{ color: '#52c41a' }}>¥ {exportPreview.totalCNY.toFixed(2)}</Text>
                    {exportPreview.totalUSD > 0 && <Text strong style={{ color: '#52c41a', marginLeft: 8 }}>$ {exportPreview.totalUSD.toFixed(2)}</Text>}
                  </div>
                  <div><Text type="secondary">订单笔数：</Text><Text strong>{exportPreview.orderCount} 笔</Text></div>
                </div>
                <div style={{ marginTop: 8, padding: '4px 8px', background: '#e6f4ff', borderRadius: 4 }}>
                  <Text type="secondary" style={{ fontSize: 12 }}>导出内容：汇总摘要 (Sheet1) + {exportPreview.orderCount} 条订单明细 (Sheet2)</Text>
                </div>
              </Card>
            )
          )}
        </Space>
      </Modal>
    </div>
  );
};

export default ShareIncome;
